import React, { memo } from 'react';
import { CheckCircle } from 'lucide-react';


const WizardIndicator = memo(({ currentStep }) => {
  const steps = [
    { step: 1, title: 'Account Selection' },
    { step: 2, title: 'Opportunity Setup' },
    { step: 3, title: 'Product Lines' },
    { step: 4, title: 'Sign-off' }
  ];

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-6">
        {steps.map((item, index) => {
          const isActive = currentStep === item.step;
          const isCompleted = currentStep > item.step;
          return (
            <div key={item.step} className="flex items-center">
              <div className={`flex items-center justify-center w-10 h-10 rounded-full border-2 transition-all ${isCompleted
                  ? 'bg-worldsview-green border-worldsview-green text-white'
                  : isActive
                    ? 'bg-worldsview-blue border-worldsview-blue text-white'
                    : 'bg-background border-border text-muted-foreground'
                }`}>
                {isCompleted ? (
                  <CheckCircle className="w-5 h-5" />
                ) : (
                  <span className="font-semibold">{item.step}</span>
                )}
              </div>
              <div className="ml-3 text-left">
                <div className={`font-medium ${isActive ? 'text-foreground' : 'text-muted-foreground'}`}>
                  {item.title}
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className={`flex-1 h-0.5 mx-6 ${isCompleted ? 'bg-worldsview-green' : 'bg-border'}`} />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
});

export { WizardIndicator };
